module.exports = __webpack_public_path__ + "static/media/beverage.9c22d384.svg";